@if(poll){
    <p class="">{{ 'polls_settings.make_recurrent.desc1' | translate: {frequency: frequency, value: value} }}</p>
    <div class="form-group" [ngClass]="{ 'pb-3': context === 'simple'}">
        <label class="form-label fst-italic py-2" for="displayDuration">{{ 'polls_settings.make_recurrent.desc2' | translate }}</label>
        <div class="d-flex justify-content-center align-items-center duration">
            <input id="displayDuration" type="number" name="displayDuration" min="1" max="15"
                    class="form-control me-2"
                    [formControl]="displayDurationCtrl"> 
            <span class="text-secondary">{{'poll_creation.schedule_duration_unit' | translate}}</span> 
        </div>
        <p class="form-text text-danger error-message" [ngClass]="{'d-none': !errorMessage && context === 'complex'}">
            @if (displayDurationCtrl.invalid && (displayDurationCtrl.dirty || displayDurationCtrl.touched)) {
                {{errorMessage}}
            }
        </p>   
    </div>       
}